//Accessible Accordions
//https://github.com/scottaohara/a11y_accordions

import a11y_accordions from "a11y_accordions";

(function() {
  const checkAccordion = document.querySelector(".accordion");
  const checkWidth = window.matchMedia("(min-width: 768px)");

  function toggleAccordion(checkWidth) {
    const panel = document.getElementById("acc_1-0_panel_1");
    const button = document.getElementById("acc_1-0_panel_1_trigger");

    if (checkWidth.matches) {
      // If media query matches

      panel.setAttribute("aria-hidden", "false");
      button.setAttribute("aria-expanded", "true");
    } else {
      panel.setAttribute("aria-hidden", "true");
      button.setAttribute("aria-expanded", "false");
    }
  }

  if (!checkAccordion) {
    return;
  } else {
    toggleAccordion(checkWidth); // Call listener function at run time
    checkWidth.addListener(toggleAccordion); // Attach listener function on state changes
  }
})();
